var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AgencyInfoService } from 'app/services/agency-info.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { ArchiveModeService } from 'app/services/archive-mode.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { AttributeFilterService } from 'app/services/attribute-filter.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { CommonTableService } from 'app/services/common-table.service';
import { DomainService } from 'app/services/domain.service';
import { EditService } from 'app/services/edit.service';
import { GtoService } from 'app/services/gto.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { LayerService } from 'app/services/layer.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { MainDataService } from 'app/services/main-data.service';
import { UserService } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';
var EditBatchComponent = /** @class */ (function () {
    function EditBatchComponent(toastr, activityService, appinfoService, archiveModeService, agencyInfoService, attrFilterService, attrIndexService, commonService, domainService, editService, gtoService, layerService, qcService, mapService, mainDataService, tableService, userService) {
        this.toastr = toastr;
        this.activityService = activityService;
        this.appinfoService = appinfoService;
        this.archiveModeService = archiveModeService;
        this.agencyInfoService = agencyInfoService;
        this.attrFilterService = attrFilterService;
        this.attrIndexService = attrIndexService;
        this.commonService = commonService;
        this.domainService = domainService;
        this.editService = editService;
        this.gtoService = gtoService;
        this.layerService = layerService;
        this.qcService = qcService;
        this.mapService = mapService;
        this.mainDataService = mainDataService;
        this.tableService = tableService;
        this.userService = userService;
        this.columns = [];
        // @Output() clickCommit: EventEmitter<any> = new EventEmitter();
        this.editClauses = [];
        this.validEditClauses = [];
        // isValid: boolean;
        this.hasChanged = false;
        this.commitDisableReason = '';
        this.filterTypes = [
            {
                label: 'Filter Count',
                type: 'filter',
                count: 0
            }, {
                label: 'Select Count',
                type: 'selection',
                count: 0
            }
        ];
        this.domainsByColumn = {};
    }
    EditBatchComponent.prototype.checkDiscardDisable = function () {
        if (this.editClauses.length === 0) {
            return true;
        }
        if (this.editClauses.length === 1) {
            return this.editClauses[0].isNew;
        }
    };
    EditBatchComponent.prototype.checkCommitDisabled = function () {
        // Disable if no clause
        if (this.editClauses.length <= 0 || !this.editClauses.find(function (c) { return !c.isNew; })) {
            this.commitDisableReason = '';
            return true;
        }
        // Disable if invalid clause exists
        var invalid = this.editClauses.find(function (c) { return !c.isNew && !c.isValid; });
        if (invalid) {
            this.commitDisableReason = 'Invalid expression';
            return true;
        }
        this.commitDisableReason = '';
        return false;
    };
    EditBatchComponent.prototype.onSelectCol = function (idx) {
        var clause = this.editClauses[idx];
        clause.val = null;
        // this.onEditClause(idx);
        if (clause.col.standardName.toLowerCase() === this.discrepancyIdStandardNameLower) {
            clause.val = this.userService.customerInfo.discrepancyId;
            // this.onInputVal(idx, 'input');
            // this.checkClauseValidity_input(idx);
        }
        this.onInputVal(idx);
        // Update nguid valid after onInputVal updating isValid
        if (clause.col && clause.col.standardName === this.nguidStandardName) {
            clause.isValid = true;
        }
    };
    EditBatchComponent.prototype.onInputVal = function (idx, type) {
        this.onEditClause(idx);
        if (type === 'select') {
            this.checkClauseValidity_domain(idx);
        }
        else {
            this.checkClauseValidity_input(idx);
        }
    };
    EditBatchComponent.prototype.checkClauseValidity_input = function (idx) {
        var clause = this.editClauses[idx];
        var check = this.editService.checkClauseVal(clause.val, clause.col, this.domainsByColumn);
        clause.isValid = check.isValid;
        if (check.isFieldCalc) {
            var rsp = true; // TODO: await this.editService.sqlValidate(this.activityService.selectedLayer.getValue(), `${check.val} as ${clause.col.name}`);
            if (rsp) {
                clause.isValid = true;
            }
            else {
                clause.isValid = false;
                this.toastr.warning('Invalid expression');
            }
        }
    };
    EditBatchComponent.prototype.checkClauseValidity_domain = function (idx) {
        return __awaiter(this, void 0, void 0, function () {
            var clause;
            return __generator(this, function (_a) {
                clause = this.editClauses[idx];
                if (clause.val || clause.val === 0 || clause.val === null) {
                    clause.isValid = true;
                }
                else {
                    clause.isValid = false;
                }
                return [2 /*return*/];
            });
        });
    };
    EditBatchComponent.prototype.onEditClause = function (idx) {
        if (idx === this.editClauses.length - 1) {
            this.editClauses[idx].isNew = false;
        }
        // this.isValid = false;
    };
    EditBatchComponent.prototype.addNewEditClause = function () {
        this.editClauses.push({
            col: null,
            operator: '=',
            val: '',
            isNew: true
        });
    };
    EditBatchComponent.prototype.getPlaceholder = function (col) {
        if (this.domainsByColumn[col.prop] && this.domainsByColumn[col.prop].type === 'list') {
            return;
        }
        var str = 'value or expression ';
        if (col.type === 'numeric') {
            str += ' eg. [' + col.prop + '] + 200';
        }
        else if (col.type === 'text') {
            str += ' eg. [' + col.prop + '] + \'my_string\'';
        }
        return str;
    };
    EditBatchComponent.prototype.removeClause = function (idx) {
        this.editClauses.splice(idx, 1);
    };
    EditBatchComponent.prototype.discard = function () {
        this.editClauses = [];
        this.addNewEditClause();
    };
    EditBatchComponent.prototype.commit = function (nguidOnly) {
        return __awaiter(this, void 0, void 0, function () {
            var spinnerId, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._commit(nguidOnly)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        });
    };
    EditBatchComponent.prototype._commit = function (nguidOnly) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedLayer, sourceTableName, prefix, primKeyCol, cols, whereClause, attrColumnFilters, mapFilter, extent, changedCols, cate, editClauses, isArchiveMode, gtos, changedColStrings;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
                        sourceTableName = selectedLayer.category.tableName;
                        prefix = selectedLayer.category.colPrefix;
                        primKeyCol = this.editService.getPrimKeyCol(prefix);
                        cols = this.editService.getUpdateColsInSourceTable(sourceTableName, prefix);
                        whereClause = '';
                        if (!this.activityService.sqlForBatch) { // Might be in schema mode, which doesn't have sql_filter. // Need to create sql frontend
                            if (selectedLayer.state.num <= 1.51) {
                                attrColumnFilters = this.attrFilterService.attrFilters.getValue().filters.filter(function (f) { return f.filter; }).map(function (f) { return f.filter; });
                                whereClause = this.editService.getWhereClauseFromColumnFilters(attrColumnFilters);
                                // WhereClause - map extent
                                // const menu = this.contentLayerService.contentMenuItemKeyBS.getValue()
                                // const viewKey: ViewMenuItemKey = this.contentLayerService.viewsBS.getValue()[menu];
                            }
                        }
                        else {
                            whereClause = this.activityService.sqlForBatch;
                        }
                        mapFilter = this.activityService.mapFilterBS.getValue();
                        // if (viewKey === 'map') {
                        if (mapFilter.isOn) {
                            extent = this.mapService.map.olMap.getView().calculateExtent();
                            whereClause = this.editService.addToWhereClause(whereClause, prefix + "_geom && ST_MakeEnvelope (" + extent[0] + "," + extent[1] + "," + extent[2] + "," + extent[3] + ",3857)");
                        }
                        // // add layer id
                        // const layerIdWhere = `${prefix}_${this.attrIndexService.layerIdColumn} = ${selectedLayer.id}`;
                        // whereClause = this.editService.addToWhereClause(whereClause, layerIdWhere);
                        if (!whereClause) {
                            console.log('something is wrong: no whereClause for batch');
                            return [2 /*return*/];
                        }
                        changedCols = {};
                        cate = this.activityService.selectedLayerBS.getValue().layer.category;
                        editClauses = nguidOnly ? this.editClauses.filter(function (c) { return c.col.standardName === _this.nguidStandardName; }) : this.editClauses;
                        editClauses.forEach(function (clause) {
                            if (!clause.isValid) {
                                return;
                            }
                            changedCols[clause.col.prop] = {
                                val: null
                            };
                            var cols = _this.columns.map(function (c) {
                                return {
                                    name: c.name,
                                    prop: c.prop
                                };
                            });
                            cate.standardCols.forEach(function (s) {
                                if (!cols.find(function (c) { return c.prop.toLowerCase() === cate.colPrefix + '_' + s.colName.toLowerCase(); })) {
                                    cols.push({
                                        name: s.colName,
                                        prop: cate.colPrefix + '_' + s.colName.toLowerCase()
                                    });
                                }
                            });
                            if (clause.col.standardName === _this.nguidStandardName) {
                                var split = '__splitString__';
                                var nguidClause = _this.agencyInfoService.computeNguid(cate.code, split); //`'urn:emergency:uri:SSAP:' || ${cate.colPrefix}_globalid || ':state.gov'+` 
                                var splits = nguidClause.split(split);
                                nguidClause = "'" + splits[0] + "' || " + cate.colPrefix + "_globalid || '" + splits[1] + "'";
                                changedCols[clause.col.prop].val = nguidClause;
                                changedCols[clause.col.prop].isExpression = true;
                            }
                            else {
                                var format = _this.editService.formatClauseValForGto(clause.val, clause.col.type, cols); // this.columns
                                changedCols[clause.col.prop].val = format.val;
                                changedCols[clause.col.prop].isExpression = format.isExpression;
                            }
                            // if (typeof(clause.val) !== 'string') {
                            // 	changedCols[clause.col.prop].val = clause.val;
                            // 	return;
                            // }
                            // // For string clause.val, it could be expression
                            // if (clause.col.type === 'numeric') {
                            // 	// Replace column in [] to real column name
                            // 	const replace = this.editService.replaceColInClause(clause.val);
                            // 	changedCols[clause.col.prop].val = replace.txt;
                            // 	if (replace.isExpression) {
                            // 		changedCols[clause.col.prop].isExpression = true;
                            // 	}
                            // 	// let strRemain = clause.val;
                            // 	// let strFinal = '';
                            // 	// const matches = clause.val.match(/\[(.*?)\]/g); // Find columns in []
                            // 	// matches.forEach((match, idx) => {
                            // 	// 	const colName = match.substring(1, match.length - 1) || ''; // column name user put
                            // 	// 	const col = this.columns.find(c => c.name.toLowerCase() === colName.toLowerCase());
                            // 	// 	const idxInRemainString = strRemain.indexOf(match);
                            // 	// 	strFinal += strRemain.substring(0, idxInRemainString - 1);
                            // 	// 	if (col) {
                            // 	// 		strFinal += `${col.prop}`;
                            // 	// 	} else {
                            // 	// 		strFinal += match;
                            // 	// 	}
                            // 	// 	// Remove match and text before match from remain string
                            // 	// 	strRemain = strRemain.substring(idxInRemainString + match.length, strRemain.length);
                            // 	// });
                            // 	// strFinal += strRemain;
                            // 	// changedCols[clause.col.prop].val = strFinal;
                            // } else if (clause.col.type === 'text') {
                            // 	// Find matchs: [column] + some_string.
                            // 			// const matchesWithPlus = clause.val.match(/\[(.*?)\]\s?\+.*?(?=((\[(.*?)\]))|$)/g);
                            // 	// let strFinal = clause.val;
                            // 	// const regex = /\[(.*?)\]\s?\+.*?(?=((\[(.*?)\]))|$)/;
                            // 	// while (regex.exec(strFinal)) {
                            // 	// 	regex.exec(strFinal)
                            // 	// }
                            // 	// // Replace + to ||
                            // 	// // Replace some_string to 'some_string'
                            // 	// let strRemain = clause.val;
                            // 	// // let strFinal = '';
                            // 	// matchesWithPlus.forEach(match => {
                            // 	// 	const idxInRemainString = strRemain.indexOf(match);
                            // 	// 	strFinal += strRemain.substring(0, idxInRemainString - 1);
                            // 	// 	// Remove match and text before match from remain string
                            // 	// 	strRemain = strRemain.substring(idxInRemainString + match.length, strRemain.length);
                            // 	// });
                            // 	// Check if [column] is followed by +, if so, replace + with ||, and add quotes to the string after it
                            // 	let replace = this.editService.replaceColAndValueInClause(clause.val);
                            // 	changedCols[clause.col.prop].val = replace.txt;
                            // 	if (replace.isExpression) {
                            // 		changedCols[clause.col.prop].isExpression = true;
                            // 	}
                            // } else {
                            // 	changedCols[clause.col.prop].val = clause.val;
                            // }
                        });
                        if (Object.keys(changedCols).length === 0) {
                            this.toastr.info('Nothing to update');
                            return [2 /*return*/];
                        }
                        isArchiveMode = this.archiveModeService.archiveModeBS.getValue().isArchive;
                        gtos = isArchiveMode ? this.editService.getUpdateGtosBatchArchive(sourceTableName, whereClause, changedCols, cols, primKeyCol, prefix).gtos : this.editService.getUpdateGtosBatch(sourceTableName, whereClause, changedCols, cols, primKeyCol, prefix).gtos;
                        if (!gtos.length) return [3 /*break*/, 2];
                        changedColStrings = Object.keys(changedCols);
                        // .map(c => {
                        // 	const std = this.mainDataService.schemas.cols.standard.find(s => s.prop === c);
                        // 	if (std) {
                        // 		return std.info.standardColName;
                        // 	} else if (c.split('_')[1] === this.attrIndexService.geomCol) { // Manually add geom col since it's removed from standard cols at beginning
                        // 		return this.attrIndexService.geomCol;
                        // 	}
                        // });
                        return [4 /*yield*/, this.editService.commitGtoAndQcForBach(gtos, changedColStrings, selectedLayer.id, prefix)];
                    case 1:
                        // .map(c => {
                        // 	const std = this.mainDataService.schemas.cols.standard.find(s => s.prop === c);
                        // 	if (std) {
                        // 		return std.info.standardColName;
                        // 	} else if (c.split('_')[1] === this.attrIndexService.geomCol) { // Manually add geom col since it's removed from standard cols at beginning
                        // 		return this.attrIndexService.geomCol;
                        // 	}
                        // });
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    EditBatchComponent.prototype.computeNguid = function () {
        this.commit(true);
    };
    EditBatchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.nguidStandardName = this.attrIndexService.nguidCol;
        this.discrepancyIdStandardNameLower = this.attrIndexService.discrepancyAgencyIdStandardLower;
        this.selectedFilterType = this.filterTypes[0];
        this.batchFilterCountSub = this.activityService.batchFilterCount.subscribe(function (data) {
            _this.filterTypes.find(function (t) { return t.type === 'filter'; }).count = data.count;
        });
        this.addNewEditClause();
    };
    EditBatchComponent.prototype.ngOnChanges = function (changes) {
        if (changes.columns && this.columns) {
            var layerCate_1 = this.activityService.selectedLayerBS.getValue().layer.category;
            var cols = this.columns.map(function (c) {
                return {
                    prop: c.prop,
                    standard: layerCate_1.standardCols.find(function (s) { return s.colName === c.standardName; })
                };
            });
            this.domainsByColumn = this.domainService.getColumnDomains(cols, layerCate_1.code);
        }
    };
    EditBatchComponent.prototype.ngOnDestroy = function () {
        this.batchFilterCountSub.unsubscribe();
    };
    return EditBatchComponent;
}());
export { EditBatchComponent };
